import React, { FC } from 'react';
import { Label } from 'semantic-ui-react';

type Props = {
  unreadCount: number;
};

export const UnReadCountLabel: FC<Props> = ({ unreadCount }) => {
  return (
    <Label
      circular={true}
      color="orange"
      floating={true}
      key="red"
      size="small"
    >
      {unreadCount}
    </Label>
  );
};
